import { isServerSide } from "src/utils/common-util";

export const isUrlPathnameSameAsCurrentPage = (url: string) => (isServerSide() ? "" : url.includes(window.location?.pathname));
